import { render } from "./b-card.vue?vue&type=template&id=27348242"
import script from "./b-card.vue?vue&type=script&lang=js"
export * from "./b-card.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__